import { render, staticRenderFns } from "./wipcostcustomer.vue?vue&type=template&id=90b09dd8&scoped=true&"
import script from "./wipcostcustomer.vue?vue&type=script&lang=js&"
export * from "./wipcostcustomer.vue?vue&type=script&lang=js&"
import style0 from "./wipcostcustomer.vue?vue&type=style&index=0&id=90b09dd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b09dd8",
  null
  
)

export default component.exports